import { TaskActionBar } from '@/features/contribution-kit';
import type { ValidateAudioCopy } from './validate-audio-copy';

type ValidateAudioActionBarProps = {
  t: Record<string, unknown>;
  copy: ValidateAudioCopy;
  isFirst: boolean;
  isLast: boolean;
  isSubmitting: boolean;
  hasAudio: boolean;
  shortcutsEnabled: boolean;
  onPrevious: () => void;
  onReject: () => void;
  onAccept: () => void;
  onNext: () => void;
  onTogglePlay: () => void;
};

/**
 * Bottom bar of "Valider les audios": previous, reject, accept, next (or
 * finish on the last audio). Same handlers as before: accept and reject keep
 * their own checks (voice required, reason required) and toasts.
 * Keys: Space plays, V accepts, R rejects, arrows move.
 */
export function ValidateAudioActionBar({
  t,
  copy,
  isFirst,
  isLast,
  isSubmitting,
  hasAudio,
  shortcutsEnabled,
  onPrevious,
  onReject,
  onAccept,
  onNext,
  onTogglePlay,
}: ValidateAudioActionBarProps) {
  const s = (key: string) => String(t[key] ?? '');
  return (
    <TaskActionBar
      shortcutsEnabled={shortcutsEnabled}
      actions={[
        { key: 'previous', label: s('previous'), icon: 'arrowLeft', onClick: onPrevious, disabled: isFirst, shortcut: 'ArrowLeft' },
        { key: 'reject', label: s('reject'), icon: 'xCircle', tone: 'danger', onClick: onReject, disabled: !hasAudio, loading: isSubmitting, shortcut: 'r', testId: 'validate-audio-reject' },
        { key: 'accept', label: copy.accept, icon: 'checkCircle', tone: 'primary', onClick: onAccept, disabled: !hasAudio, loading: isSubmitting, shortcut: 'v', testId: 'validate-audio-accept' },
        {
          key: 'next',
          label: isLast ? s('finishSession') : s('next'),
          icon: isLast ? 'checkCircle' : 'arrowRight',
          onClick: onNext,
          shortcut: 'ArrowRight',
        },
      ]}
      extraShortcuts={[{ key: ' ', run: onTogglePlay, enabled: hasAudio }]}
      hints={[{ key: ' ', label: copy.play }]}
    />
  );
}
